var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ml-2 tabs",attrs:{"id":_vm.id},on:{"click":_vm.changeTab}},[_c('b-icon',{attrs:{"title":"agrega una tab","icon":"file-code"}}),_c('b-icon',{attrs:{"title":"cierra la tab","scale":"1","icon":"x"},on:{"click":function($event){return _vm.delspace()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }